class BookingRequest {
  static create = {
    bookingCustomerId: null,
    bookingProfessionalId: null,
    bookingTopic: null,
    bookingAvailableTime: null,
    bookingAmount: null,
    bookingMessage: null
  };
  static readBy = {
    bookingId: null
  };
  static readByCustomerId = {
    bookingCustomerId: null
  };
  static readByProfessionalId = {
    bookingProfessionalId: null
  };
  static cancel = {
    bookingId: null
  };
  static reschedule = {
    bookingId: null,
    bookingAvailableTime: null
  };
  static readPendingReviews = {
    customerId: null
  };
  static updateReview = {
    bookingId: null,
    reviewerId: null,
    reviewerType: null,
    rating: null,
    comment: null
  };
}

export default BookingRequest;
